import {forwardAsync} from "@babel/core/lib/gensync-utils/async";

var $ = require("jquery");
window.jQuery = $;
import 'slick-carousel';
require("@fancyapps/fancybox");
import zenscroll from "zenscroll";
import 'jquery-validation/dist/jquery.validate.min';

var defaultDuration = 777;
var edgeOffset = 50;
zenscroll.setup(defaultDuration, edgeOffset);

$('.jsCarouselHB').slick({
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
});

$('.jsGallery').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
});

$('.jsPlantsCarousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 589,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.jsProductCarousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 589,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.jsGalleryThumbs').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
});

$('.jsCarouselClients').slick({
    infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 569,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
});

$('.jsCarouselReviews').slick({
    infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 989,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
});

$('.jsCarouselReviewsSingle').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
});

$(function() {


    $('.jsSlideZoom').on('click', function() {
        var activeSlide = $('.jsGallery .slick-current');
        //console.log($('a', activeSlide).attr('href'));

        $('a', activeSlide).eq(0).trigger("click");
    });

    $('.jsGalleryThumb').on('click', function() {
        var slide = $(this).closest('.slick-slide');
        var slideIndex = $(slide).data('slick-index');
        var slider = $('.jsGallery');
        slider[0].slick.slickGoTo(parseInt(slideIndex));
    });

    $("#product-guide-form").validate({
        rules: {
            EMAIL: {
                required: true,
                email: true
            }
        },
        messages: {
            email: "Please enter a valid email address"
        }
    });

    $("#contact-form").validate({
        invalidHandler: function(event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                $('.jsFormError').show();
            }
        },
        rules: {
            name: "required",
            phone: {
                required: true,
                minlength: 8,
                maxlength: 13
            },
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            name: "Please enter your name",
            phone: "Please enter a valid telephone number",
            email: "Please enter a valid email address"
        },
        submitHandler: function(form) {

            $('.jsFormError').hide();
            var formData = $(form).serialize();

            $.ajax({
                url: "https://sys.inleaf.co.uk/website/enquiries2/push",
                type: "POST",
                data: formData,
                cache: false,
                processData: false,
                success: function(data) {
                    $('.jsOverlay').show();
                    $('.jsPolicyForm').removeClass('active');
                    $('.jsFormSuccess').addClass('active');
                    $(form).trigger("reset");
                }
            }).done(function(response) {
            }).fail(function(response) {
                $('.jsFormError').show();
            }).always(function(response) {
            });
            return false;
        },
    });

    $("#bespoke-design-form").validate({
        invalidHandler: function(event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                $('.jsFormError').show();
            }
        },
        rules: {
            name: "required",
            phone: {
                required: true,
                minlength: 8,
                maxlength: 13
            },
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            full_name: "Please enter your firstname",
            phone: "Please enter a valid telephone number",
            email: "Please enter a valid email address"
        },
        submitHandler: function(form) {

            $('.jsFormError').show();
            var formData = $(form).serialize();

            $.ajax({
                url: "https://sys.inleaf.co.uk/website/enquiries2/push",
                type: "POST",
                data: formData,
                cache: false,
                processData: false,
                success: function(data) {
                    //console.log(data['status']);
                    toggleSideFormFormSuccess();
                }
            }).done(function(response) {
            }).fail(function(response) {
            }).always(function(response) {
            });
            return false;
        },
    });

    $("#bespoke-design-form").focusout(function() {
        var form = $('#bespoke-design-form');
        calculateFormProgress(form)
    });

    function calculateFormProgress(form){

        var validCount = 0;

        $("[required]", form).each(function() {

            if($(this).val() && $(this).hasClass('valid')) {
                validCount++;
            }

        });

        var requiredCount = $("[required]", form).length;
        var progress = Math.ceil((validCount / requiredCount) * 100);

        $('.jsProgressBarLine').css('width', progress + '%');
        $('.jsProgressBarText').html(progress + '% Complete');
    }

    $('.jsCtaMobileTab1').on('click', function() {
        $('.jsCtaMobileTab2').removeClass('active');
        $(this).toggleClass('active');
        $('.jsStepCta1').toggleClass('mobile-active');
        $('.jsStepCta2').removeClass('mobile-active');
        if ($('.jsStepCta1').hasClass('mobile-active')) {
            $('.jsOverlay').show();
            $('aside').addClass('mobile-active');
        } else {
            $('.jsOverlay').hide();
            $('aside').removeClass('mobile-active');
        }

    });

    $('.jsCtaMobileTab2').on('click', function() {
        $('.jsCtaMobileTab1').removeClass('active');
        $(this).toggleClass('active');
        $('.jsStepCta2').toggleClass('mobile-active');
        $('.jsStepCta1').removeClass('mobile-active');
        if ($('.jsStepCta2').hasClass('mobile-active')) {
            $('.jsOverlay').show();
            $('aside').addClass('mobile-active');
        } else {
            $('.jsOverlay').hide();
            $('aside').removeClass('mobile-active');
        }
    });

    $('.jsToggleFormSuccess').on('click', function(e) {
        e.preventDefault();
        $('.jsFormSuccess').toggleClass('active');
        $('.jsOverlay').toggle();
    });

    $('.jsToggleNextStepForm').on('click', function(e) {
        e.preventDefault();
        //var screenTop = $(document).scrollTop();
        toggleNextStepForm();
    });

    function toggleNextStepForm() {
        $('.jsNextStepForm').css('top', 0);
        $('body').toggleClass('pop-up-form-open');
        $('.jsNextStepForm').toggleClass('active');
        $('.jsOverlay').toggle();
        //toggleFormSuccess();
    }

    function toggleSideFormFormSuccess() {
        $('.jsSideFormInit').hide();
        $('.jsSideFormSuccess').show();
    }

    const urlParams = new URLSearchParams(window.location.search);
    const formParam = urlParams.get('form');
    if (formParam == 'next-step') {
        toggleNextStepForm();
        if ( urlParams.get('success')) {
            toggleSideFormFormSuccess();
        }
    }

    $('.jsDownloadFormToggle').on('click', function() {
        $('body').toggleClass('pop-up-form-open');
        $('.jsDownloadForm').toggleClass('active');
        $('.jsOverlay').toggle();
    });

    $('.jsPolicyFormToggle').on('click', function() {
        $('body').toggleClass('pop-up-form-open');
        $('.jsPolicyForm').toggleClass('active');
        $('.jsOverlay').toggle();
    });

    $('.jsOverlay').on('click', function() {
        $('body').removeClass('pop-up-form-open');
        $('.jsDownloadForm').removeClass('active');
        $('.jsNextStepForm').removeClass('active');
        $('.jsFormSuccess').removeClass('active');
        $('.jsPolicyForm').removeClass('active');
        $('.jsStepCta1').removeClass('mobile-active');
        $('.jsStepCta2').removeClass('mobile-active');
        $('.jsCtaMobileTab1').removeClass('active');
        $('aside').removeClass('mobile-active');
        $('.jsOverlay').hide();
    });

    $('.jsPostCodeSearch').on('click', function(e) {
        e.preventDefault();
        $('.jsLocationFormError').html('');

        // Scroll to result set
        let postcode = $('.jsPostCode').val();
        postcode = postcode.replace(/\s/g, ''); // remove spaces
        postcode = postcode.toUpperCase();
        let outcode = postcode;

        let regexp = /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/;
        let parts = postcode.match(regexp);

        if (parts) {
            outcode = parts[1];
        }

        outcode = outcode.replace(/\d+/g, '')

        if (!valid_uk_postcode(outcode)) {
            $('.jsLocationFormError').html('Please enter a valid UK postcode');
        } else {
            let locationFound = false;

            $('.jsLocationItem').each(function() {
                if ($(this).hasClass(outcode)) {
                    let location = $(this).clone();
                    $(location).addClass('active');
                    $('.jsNearestLocation div').html(location);
                    $('.jsNearestLocation').show();
                    locationFound = true;
                    zenscroll.to(document.getElementById('location-nearest'));
                    return false;
                }
            });

            if (!locationFound) {
                $('.jsLocationFormError').html('No branch could be found for your postcode');
            }
        }
    });

    function valid_uk_postcode(postcode) {
        postcode = postcode.replace(/\s/g, "") + "1"; // Add 1 to end as we are only searching by outcode letters
        var regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1}$/i;
        return regex.test(postcode);
    }

    $('.jsLocationItemToggle').on('click', function() {
        var open = false;
        if ($(this).closest('.jsLocationItem').hasClass('active')) {
            open = true;
        }
        $(".jsLocationItem").removeClass('active');
        if (!open) {
            $(this).closest('.jsLocationItem').addClass('active');
        }
    });

    $('.jsLocationPin').on('click', function() {
        $('.jsLocationPin').removeClass('active');
        $(this).addClass('active');
        $(".jsLocationItem").removeClass('active');
        var locationID = $(this).data('location');
        var locationItem = $(".jsLocationItems").find("[data-location='" + locationID + "']");
        $(locationItem).addClass('active');
    });

    $('.jsLocationPin').hover(
        function() {
            var locationID = $(this).data('location');
            var locationItem = $(".jsLocationItems").find("[data-location='" + locationID + "']");
            $('.jsLocationItemName', locationItem).addClass('active');
        }, function() {
            var locationID = $(this).data('location');
            var locationItem = $(".jsLocationItems").find("[data-location='" + locationID + "']");
            $('.jsLocationItemName', locationItem).removeClass('active');
        }
    );

    $('.jsLocationItem').hover(
        function() {
            var locationID = $(this).data('location');
            var locationMapItem = $(".jsLocationsMap").find("[data-location='" + locationID + "']");
            $(locationMapItem).addClass('active');
        }, function() {
            var locationID = $(this).data('location');
            var locationMapItem = $(".jsLocationsMap").find("[data-location='" + locationID + "']");
            $(locationMapItem).removeClass('active');
        }
    );

    $('.jsMobileNavToggle').on('click', function() {
        $('body').toggleClass('mobile-nav-active');
        return false;
    });

    if ($(window).width() < 589) {
        $('body').addClass('use-mobile-nav');
    }

    $('.use-mobile-nav .jsMainNav .jsMenuLinkEnd').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log('test');
        var parent = $(this).closest('.menu-item');
        console.log(parent);
        $(parent).toggleClass('mobile-active-dropdown');
        return false;
    });

});

if($('.jsStickSide').length > 0) {
    window.onscroll = function () {
        stickySide()
    };

    stickySide();
}

function stickySide() {

    var offset = 150;

    if($('.c-hb').length > 0) {
        offset = 600;
    }

    if (window.pageYOffset >= offset) {
        $('.jsStickSide').addClass('sticky');
    } else {
        $('.jsStickSide').removeClass('sticky');
    }
}


